/**
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { Suspense } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import './assets/fonts/DinBold.otf';
import { ContextProvider } from './Context';

// Import i18n configuration
import './i18n/i18n';

// Global CSS imports - must be imported in a fixed order to avoid conflicts
// Import all global/shared CSS files here before any component imports
import 'flatpickr/dist/flatpickr.css';
import 'swiper/swiper.min.css';
import 'swiper/css/navigation';
import './style.css';
import './examples/Navbars/DefaultNavbar/style.css';
import './pages/Blog/style.css';
import './pages/Clinical/style.css';
import './pages/Publications/style.css';
import './pages/Partenaires/style.css';
import './pages/Team/style.css';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

// Styles pour l'animation de chargement initial
const loadingStyles = `
  @keyframes pulse {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
    40% { transform: scale(1); opacity: 1; }
  }
  .initial-loading-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #C65D3B;
    animation: pulse 1.4s ease-in-out infinite;
  }
  .initial-loading-dot:nth-child(1) { animation-delay: 0s; }
  .initial-loading-dot:nth-child(2) { animation-delay: 0.2s; }
  .initial-loading-dot:nth-child(3) { animation-delay: 0.4s; }
`;

// Composant de chargement initial
const InitialLoading = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      gap: '20px',
      backgroundColor: '#fafafa',
    }}
  >
    <style>{loadingStyles}</style>
    <div style={{ display: 'flex', gap: '8px' }}>
      <div className="initial-loading-dot" />
      <div className="initial-loading-dot" />
      <div className="initial-loading-dot" />
    </div>
  </div>
);

// Utilisation de Suspense pour gérer le chargement des traductions
root.render(
  <BrowserRouter>
    <ContextProvider>
      <Suspense fallback={<InitialLoading />}>
        <App />
      </Suspense>
    </ContextProvider>
  </BrowserRouter>
);
